import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { LoadingState } from '../components';
import { useSession } from '../hooks/use-auth';

/**
 * Guarda de rota (RF-F02). Preserva o destino pretendido no `state` para que o
 * login devolva o usuário exatamente onde ele tentou entrar — perder o destino
 * transformaria um link compartilhado em ida ao dashboard.
 */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const location = useLocation();
  const { data, isPending } = useSession();

  if (isPending) {
    return (
      <div className="mx-auto max-w-content p-6">
        <LoadingState label="Verificando sessão" />
      </div>
    );
  }

  if (!data?.user) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  return <>{children}</>;
}
